export const CHIP_UNCHECKED_LABEL = 'Unchecked' as const;

export const REQUIREMENT_DONE_LIVE_ARIA_LABEL = 'Done, deployed, and live';

export const DEPLOY_CHIP_LABEL: Record<string, string> = {
  live: 'Live',
  not_deployed: 'Not Deployed',
  deploy_failed: 'Deploy Failed',
  checking: 'Checking...',
  unknown: 'Unverified',
};

const UNCHECKED_IMPL_STATUSES = new Set(['Not Checked', 'Unknown', 'No Repo']);

export function isImplChipUnchecked(status: string): boolean {
  return UNCHECKED_IMPL_STATUSES.has(status);
}

export function isDeployChipUnchecked(status?: string): boolean {
  return !status || status === 'not_checked';
}

export function resolveDeployChipLabel(status?: string): string {
  if (isDeployChipUnchecked(status)) return CHIP_UNCHECKED_LABEL;
  return DEPLOY_CHIP_LABEL[status ?? ''] ?? status ?? CHIP_UNCHECKED_LABEL;
}

export function resolveLinearChipLabel(issueIdentifier?: string, status?: string): string {
  if (!issueIdentifier) return CHIP_UNCHECKED_LABEL;
  if (status) return `${issueIdentifier} · ${status}`;
  return issueIdentifier;
}
